import React__default, { createElement, Component, Children, cloneElement } from 'react';
import styled, { ThemeProvider, createGlobalStyle, keyframes } from 'styled-components';
import { Route, Router as Router$1, Switch as Switch$1, Redirect as Redirect$1 } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Router, Switch, Redirect, Route as Route$1 } from 'react-router';
import ReactDom from 'react-dom';

var AuthenticationManagerImp =
/** @class */
function () {
  function AuthenticationManagerImp() {
    this.signUp = function (_, __) {
      return Promise.resolve();
    };

    this.signIn = function (_, __, ___) {
      return Promise.resolve();
    };

    this.signOut = function () {
      return Promise.resolve();
    };

    this.forgotPassword = function (_) {
      return Promise.resolve();
    };

    this.isSignedIn = function () {
      return false;
    };

    this.isReady = function () {
      return false;
    };

    this.onManagerReadyStateChanged = function (callback) {
      return function () {
        return callback;
      };
    };

    this.onAuthenticationStateChanged = function (callback) {
      return function () {
        return callback;
      };
    };

    this.getUser = function () {
      return Promise.resolve(null);
    };
  }

  return AuthenticationManagerImp;
}();

var PRIMARY_COLOR = 'black';
var SECONDARY_COLOR = 'red';
var BACKGROUND_COLOR = 'white';
var CMSDefaultTheme = {
  mobileWidthBoundry: '768px',
  loader: {
    color: PRIMARY_COLOR
  },
  header: {
    desktopHeight: '65px',
    mobileHeight: '50px',
    backgroundColor: PRIMARY_COLOR,
    menuIconColor: BACKGROUND_COLOR
  },
  avatar: {
    backgroundColor: BACKGROUND_COLOR
  },
  menu: {
    backgroundColor: PRIMARY_COLOR,
    defaultTextColor: BACKGROUND_COLOR,
    rowSeperatorColor: 'rgba(50,50,50,1)',
    selectedBackgroundColor: 'grey'
  },
  authMenu: {
    backgroundColor: BACKGROUND_COLOR,
    defaultTextColor: PRIMARY_COLOR,
    rowSeperatorColor: 'rgba(210,210,210,1)',
    selectedBackgroundColor: 'grey'
  },
  input: {
    borderColor: PRIMARY_COLOR,
    backgroundColor: BACKGROUND_COLOR,
    titleTextColor: PRIMARY_COLOR,
    messageTextColor: PRIMARY_COLOR,
    textColor: PRIMARY_COLOR
  },
  button: {
    backgroundColor: PRIMARY_COLOR,
    titleColor: BACKGROUND_COLOR,
    activeBackgroundColor: SECONDARY_COLOR,
    activeTitleColor: PRIMARY_COLOR
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

var Header = styled.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    background-color: ", ";\n    align-items: center;\n    height: ", ";\n    width: 100%;\n    @media (max-width: ", ") {\n        height: ", ";\n    }\n    ", "\n"], ["\n    display: flex;\n    background-color: ", ";\n    align-items: center;\n    height: ", ";\n    width: 100%;\n    @media (max-width: ", ") {\n        height: ", ";\n    }\n    ", "\n"])), function (_a) {
  var t = _a.theme;
  return t.header.backgroundColor;
}, function (_a) {
  var t = _a.theme;
  return t.header.desktopHeight;
}, function (_a) {
  var t = _a.theme;
  return t.mobileWidthBoundry;
}, function (_a) {
  var t = _a.theme;
  return t.header.mobileHeight;
}, function (_a) {
  var sticky = _a.sticky;
  return sticky && "\n        position: fixed;\n        top: 0px;\n    ";
});
var templateObject_1;
var HeaderContentContainer = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    display: flex;\n    flex: 1;\n    padding: 5px;\n    align-items: center;\n    ", "\n"], ["\n    display: flex;\n    flex: 1;\n    padding: 5px;\n    align-items: center;\n    ", "\n"])), function (_a) {
  var _b = _a.contentAllignment,
      contentAllignment = _b === void 0 ? 'left' : _b;
  return "\n        justify-content: " + {
    'left': 'flex-start',
    'center': 'center',
    'right': 'flex-end'
  }[contentAllignment] + "\n    ";
});
var templateObject_1$1;
var DIV = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n    color: ", ";\n    width: ", "px;\n    height: ", "px;\n    cursor: pointer;\n    &:active {\n        opacity: 0.4;\n    }\n"], ["\n    color: ", ";\n    width: ", "px;\n    height: ", "px;\n    cursor: pointer;\n    &:active {\n        opacity: 0.4;\n    }\n"])), function (_a) {
  var theme = _a.theme;
  return "" + theme.header.menuIconColor;
}, function (props) {
  return "" + (props.width || 20);
}, function (props) {
  return "" + (props.height || 20);
});
var SVG = styled.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n"], ["\n    width: 100%;\n    height: 100%;\n"])));

var MenuIcon = function MenuIcon(props) {
  return createElement(DIV, _assign({}, props), createElement(SVG, {
    viewBox: "0 0 448 512"
  }, createElement("path", {
    fill: "currentColor",
    d: "M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"
  })));
};

var templateObject_1$2, templateObject_2;
var Container = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n    flex-shrink: 0;\n    color: ", ";\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    &:active {\n        opacity: 0.4;\n    }\n    display: block;\n"], ["\n    flex-shrink: 0;\n    color: ", ";\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    &:active {\n        opacity: 0.4;\n    }\n    display: block;\n"])), function (_a) {
  var theme = _a.theme;
  return "" + theme.header.menuIconColor;
});
var SVG$1 = styled.svg(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n"], ["\n    width: 100%;\n    height: 100%;\n"])));
var Photo = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-image: url(", ");\n    background-color: ", ";\n    background-size: cover;\n"], ["\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background-image: url(", ");\n    background-color: ", ";\n    background-size: cover;\n"])), function (_a) {
  var photoURL = _a.photoURL;
  return photoURL;
}, function (_a) {
  var theme = _a.theme;
  return "" + theme.header.menuIconColor;
});

var CMSAvatar = function CMSAvatar(props) {
  var photoURL = props.photoURL,
      _a = props.theme,
      theme = _a === void 0 ? CMSDefaultTheme : _a;
  return createElement(ThemeProvider, {
    theme: theme
  }, createElement(Container, _assign({}, props), photoURL ? createElement(Photo, {
    photoURL: photoURL
  }) : createElement(SVG$1, {
    viewBox: "0 0 512 512"
  }, createElement("g", null, createElement("path", {
    fill: "currentColor",
    d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 96a88 88 0 1 1-88 88 88 88 0 0 1 88-88zm0 344a191.63 191.63 0 0 1-146.5-68.2c18.8-35.4 55.6-59.8 98.5-59.8a24.47 24.47 0 0 1 7.1 1.1 124.67 124.67 0 0 0 81.8 0 24.47 24.47 0 0 1 7.1-1.1c42.9 0 79.7 24.4 98.5 59.8A191.63 191.63 0 0 1 256 448z",
    opacity: "0.4"
  }), createElement("path", {
    fill: "currentColor",
    d: "M256 280a88 88 0 1 0-88-88 88 88 0 0 0 88 88zm48 40a24.47 24.47 0 0 0-7.1 1.1 124.67 124.67 0 0 1-81.8 0 24.47 24.47 0 0 0-7.1-1.1c-42.9 0-79.7 24.4-98.5 59.8a191.45 191.45 0 0 0 293 0C383.7 344.4 346.9 320 304 320z"
  })))));
};

var templateObject_1$3, templateObject_2$1, templateObject_3;

var StyledIconComponent = function StyledIconComponent(IconComponent) {
  return styled(IconComponent)(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n    margin-left: 15px;\n    margin-right: 15px;\n    width: 30px;\n    height: 30px;\n    @media (max-width: ", ") {\n        margin-left: 10px;\n        margin-right: 10px;\n        width: 25px;\n        height: 25px;\n    }\n"], ["\n    margin-left: 15px;\n    margin-right: 15px;\n    width: 30px;\n    height: 30px;\n    @media (max-width: ", ") {\n        margin-left: 10px;\n        margin-right: 10px;\n        width: 25px;\n        height: 25px;\n    }\n"])), function (_a) {
    var t = _a.theme;
    return t.mobileWidthBoundry;
  });
};

var MenuIcon$1 = StyledIconComponent(MenuIcon);
var UserIcon = StyledIconComponent(CMSAvatar);

var CMSHeader =
/** @class */
function (_super) {
  __extends(CMSHeader, _super);

  function CMSHeader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CMSHeader.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        _b = _a.theme,
        theme = _b === void 0 ? CMSDefaultTheme : _b,
        _c = _a.showMenuIcon,
        showMenuIcon = _c === void 0 ? true : _c,
        _d = _a.showUserIcon,
        showUserIcon = _d === void 0 ? true : _d,
        _e = _a.sticky,
        sticky = _e === void 0 ? false : _e,
        _f = _a.onClickMenuIcon,
        onClickMenuIcon = _f === void 0 ? function () {
      return null;
    } : _f,
        _g = _a.onClickUserIcon,
        onClickUserIcon = _g === void 0 ? function () {
      return null;
    } : _g,
        children = _a.children,
        user = _a.user;
    var photoURL = user ? user.photoURL : null;
    return createElement(ThemeProvider, {
      theme: theme
    }, createElement(Header, {
      className: className,
      sticky: sticky
    }, showMenuIcon && createElement(MenuIcon$1, {
      onClick: onClickMenuIcon
    }), createElement(HeaderContentContainer, {
      contentAllignment: 'center'
    }, children), showUserIcon && createElement(UserIcon, {
      onClick: onClickUserIcon,
      photoURL: photoURL
    })));
  };

  return CMSHeader;
}(Component);

var templateObject_1$4;
var CMSGlobalStyle = createGlobalStyle(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  html, body {\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n  }\n"], ["\n  html, body {\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n  }\n"])));
var templateObject_1$5;
var MenuContainer = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n    width: 100vw;\n    height: 100vh;\n    max-width: 280px;\n    transform: translate3d(", ", 0, 0);\n    transition: transform ", "ms;\n    background-color: ", ";\n    border-right: 0.4pt solid ", ";\n"], ["\n    width: 100vw;\n    height: 100vh;\n    max-width: 280px;\n    transform: translate3d(", ", 0, 0);\n    transition: transform ", "ms;\n    background-color: ", ";\n    border-right: 0.4pt solid ", ";\n"])), function (_a) {
  var _b = _a.visible,
      visible = _b === void 0 ? false : _b;
  return visible ? '0' : '-320px';
}, function (_a) {
  var _b = _a.animationDuration,
      animationDuration = _b === void 0 ? 300 : _b;
  return "" + animationDuration;
}, function (_a) {
  var theme = _a.theme;
  return theme.menu.backgroundColor;
}, function (_a) {
  var theme = _a.theme;
  return theme.menu.rowSeperatorColor;
});

var Menu = function Menu(props) {
  return createElement(MenuContainer, _assign({
    onClick: function onClick(event) {
      return event.stopPropagation();
    }
  }, props));
};

var templateObject_1$6;
var Backdrop = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, ", ");\n    transition: background ", "ms;\n"], ["\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, ", ");\n    transition: background ", "ms;\n"])), function (_a) {
  var _b = _a.visible,
      visible = _b === void 0 ? true : _b;
  return visible ? '0.4' : '0';
}, function (_a) {
  var _b = _a.animationDuration,
      animationDuration = _b === void 0 ? 300 : _b;
  return "" + animationDuration;
});
var templateObject_1$7;
var HeaderContainer = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n    width: 100%;\n    height: 65px;\n    padding: 12px 15px 12px 15px;\n    overflow: hidden;\n    box-sizing: border-box;\n    border-bottom: 0.4pt solid ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n    width: 100%;\n    height: 65px;\n    padding: 12px 15px 12px 15px;\n    overflow: hidden;\n    box-sizing: border-box;\n    border-bottom: 0.4pt solid ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.menu.rowSeperatorColor;
});
var HeaderTitle = styled.span(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n    color: ", " ;\n    font-size: 12pt;\n    font-weight: bold;\n"], ["\n    color: ", " ;\n    font-size: 12pt;\n    font-weight: bold;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.menu.defaultTextColor;
});
var HeaderSubtitle = styled.span(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n    color: ", " ;\n    font-size: 9pt;\n"], ["\n    color: ", " ;\n    font-size: 9pt;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.menu.defaultTextColor;
});

var Header$1 = function Header$1(_a) {
  var title = _a.title,
      subtitle = _a.subtitle;
  return createElement(HeaderContainer, null, createElement(HeaderTitle, null, title), createElement(HeaderSubtitle, null, subtitle));
};

var templateObject_1$8, templateObject_2$2, templateObject_3$1;
var MenuItemContainer = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    width: 100%;\n    height: 44px;\n    padding: 12px 15px 12px 15px;\n    overflow: hidden;\n    box-sizing: border-box;\n    border-bottom: 0.4pt solid ", ";\n    transition: 300ms;\n    :hover {\n        background-color: grey;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    width: 100%;\n    height: 44px;\n    padding: 12px 15px 12px 15px;\n    overflow: hidden;\n    box-sizing: border-box;\n    border-bottom: 0.4pt solid ", ";\n    transition: 300ms;\n    :hover {\n        background-color: grey;\n    }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.menu.rowSeperatorColor;
});
var ItemTitle = styled.span(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 12pt;\n    font-weight: ", ";\n"], ["\n    color: ", ";\n    font-size: 12pt;\n    font-weight: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.menu.defaultTextColor;
}, function (_a) {
  var selected = _a.selected;
  return selected ? 'bold' : '300';
});

var MenuItem = function MenuItem(props) {
  var title = props.title,
      _a = props.onClick,
      _onClick = _a === void 0 ? function () {
    return null;
  } : _a,
      _b = props.selected,
      selected = _b === void 0 ? false : _b;

  return createElement(MenuItemContainer, {
    onClick: function onClick(event) {
      _onClick(props);

      event.preventDefault();
    }
  }, createElement(ItemTitle, {
    selected: selected
  }, title));
};

var templateObject_1$9, templateObject_2$3;

var CMSMenu =
/** @class */
function (_super) {
  __extends(CMSMenu, _super);

  function CMSMenu() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CMSMenu.prototype.render = function () {
    var _a = this.props,
        _b = _a.theme,
        theme = _b === void 0 ? CMSDefaultTheme : _b,
        title = _a.title,
        subtitle = _a.subtitle,
        _c = _a.MenuHeaderComponent,
        MenuHeaderComponent = _c === void 0 ? Header$1 : _c,
        _d = _a.menuItems,
        menuItems = _d === void 0 ? [] : _d,
        _e = _a.visible,
        visible = _e === void 0 ? false : _e,
        _f = _a.onDismiss,
        onDismiss = _f === void 0 ? function () {
      return null;
    } : _f,
        _g = _a.onClickMenuItem,
        onClickMenuItem = _g === void 0 ? null : _g,
        _h = _a.history,
        history = _h === void 0 ? null : _h;
    return createElement(ThemeProvider, {
      theme: theme
    }, createElement(Backdrop, {
      visible: visible,
      onClick: onDismiss
    }, createElement(Menu, {
      visible: visible
    }, createElement(MenuHeaderComponent, {
      title: title,
      subtitle: subtitle
    }), menuItems.map(function (props, index) {
      var component = props.component,
          onClick = props.onClick,
          otherProps = __rest(props, ["component", "onClick"]);

      var Component = component || MenuItem;

      var onClickWrapped = function onClickWrapped() {
        (onClickMenuItem || onClick || function () {
          return null;
        })(_assign({}, props, {
          history: history
        }));
      };

      return createElement(Component, _assign({
        key: index,
        onClick: onClickWrapped
      }, otherProps, {
        history: history
      }));
    }))));
  };

  return CMSMenu;
}(Component);

var CMSContext =
/** @class */
function () {
  function CMSContext(history, lister) {
    var _this = this;

    this.setParams = function (params) {
      var prevState = params.prevState,
          otherParams = __rest(params, ["prevState"]);

      prevState = null;
      _this.state = _assign({}, _this.state, otherParams);

      _this._lister();
    };

    this.getParam = function (key, defaultValue) {
      return _this.state[key] || defaultValue;
    };

    this.onHistoryChanged = function (_, action) {
      if (action === 'PUSH') {
        _this.state = {
          prevState: _this.state
        };
      } else {
        _this.state = _this.state.prevState || {};
      }
    };

    this.history = history;
    this._lister = lister;
    this.state = {};
  }

  Object.defineProperty(CMSContext.prototype, "history", {
    get: function get() {
      return this._history;
    },
    set: function set(history) {
      if (this._unsubscribeHistoryEvents) {
        this._unsubscribeHistoryEvents();
      }

      this._history = history || this._history || createBrowserHistory();
      this._unsubscribeHistoryEvents = this._history.listen(this.onHistoryChanged);
    },
    enumerable: true,
    configurable: true
  });
  return CMSContext;
}();

var Container$1 = styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100vw;\n    height: 100vh;\n    overflow-y: scroll;\n"], ["\n    display: flex;\n    flex-direction: column;\n    width: 100vw;\n    height: 100vh;\n    overflow-y: scroll;\n"])));
var templateObject_1$a;
var OverlayComponentContainer = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n    display: ", ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n"], ["\n    display: ", ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n"])), function (props) {
  return props.visible ? 'initial' : 'none';
});
var templateObject_1$b;
var HeaderComponentContainer = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n    flex: 0;\n    background-color: black;\n"], ["\n    flex: 0;\n    background-color: black;\n"])));
var templateObject_1$c;
var ContentComponentContainer = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n    flex: 1;\n"], ["\n    flex: 1;\n"])));
var templateObject_1$d;
var FooterComponentContainer = styled.div(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n    flex: 0;\n"], ["\n    flex: 0;\n"])));
var templateObject_1$e;

var getChildrenMenuItems = function getChildrenMenuItems(children, itemProps) {
  var menuItems = Array();
  React__default.Children.forEach(children, function (child) {
    if (child.props && child.props.component) {
      var menuItem = child.props.component.menuItem || child.props.menuItem || null;

      if (menuItem instanceof Function) {
        menuItem = menuItem(itemProps || {});
      }

      if (menuItem) {
        menuItems.push(menuItem);
      }
    }
  });
  return menuItems;
};

var applyScreenPropsToChildren = function applyScreenPropsToChildren(children, props) {
  return React__default.Children.map(children, function (child, index) {
    if (child.type === CMSScreen) {
      var Component_1 = child.props.component;
      return React__default.createElement(Route, {
        path: child.props.path,
        exact: child.props.exact,
        render: function render(routeProps) {
          return React__default.createElement(Component_1, _assign({}, routeProps, props));
        }
      });
    }

    return React__default.cloneElement(child, _assign({}, props, {
      key: index
    }));
  });
};

var CMSScreen =
/** @class */
function (_super) {
  __extends(CMSScreen, _super);

  function CMSScreen() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CMSScreen.prototype.render = function () {
    return null; //
  };

  return CMSScreen;
}(Component);

var CMSComponent = function CMSComponent(props) {
  var headerTitle = props.headerTitle,
      headerSubtitle = props.headerSubtitle,
      _a = props.HeaderComponent,
      HeaderComponent = _a === void 0 ? function () {
    return null;
  } : _a,
      _b = props.MenuComponent,
      MenuComponent = _b === void 0 ? function () {
    return null;
  } : _b,
      _c = props.AccountMenuComponent,
      AccountMenuComponent = _c === void 0 ? function () {
    return null;
  } : _c,
      _d = props.FooterComponent,
      FooterComponent = _d === void 0 ? function () {
    return null;
  } : _d,
      defaultChildren = props.children,
      showMenuContainer = props.showMenuContainer,
      showMenu = props.showMenu,
      showAccountMenuContainer = props.showAccountMenuContainer,
      showAccountMenu = props.showAccountMenu,
      cmsContext = props.cmsContext,
      onDismissMenu = props.onDismissMenu,
      onDismissAccountMenu = props.onDismissAccountMenu,
      onClickMenuItem = props.onClickMenuItem,
      onClickMenuIcon = props.onClickMenuIcon,
      onClickUserIcon = props.onClickUserIcon,
      history = props.history,
      user = props.user,
      onClickShowAccountSettings = props.onClickShowAccountSettings,
      onClickSignOut = props.onClickSignOut;
  var itemProps = {
    context: cmsContext
  };
  var menuItems = getChildrenMenuItems(defaultChildren, itemProps);
  var children = applyScreenPropsToChildren(defaultChildren, itemProps);
  return React__default.createElement(Container$1, null, React__default.createElement(OverlayComponentContainer, {
    visible: showMenuContainer
  }, React__default.createElement(MenuComponent, {
    title: headerTitle,
    subtitle: headerSubtitle,
    visible: showMenu,
    onDismiss: onDismissMenu,
    menuItems: menuItems,
    onClickMenuItem: onClickMenuItem,
    history: history
  })), React__default.createElement(OverlayComponentContainer, {
    visible: showAccountMenuContainer
  }, React__default.createElement(AccountMenuComponent, {
    visible: showAccountMenu,
    onDismiss: onDismissAccountMenu,
    user: user,
    onClickShowAccountSettings: onClickShowAccountSettings,
    onClickSignOut: onClickSignOut
  })), React__default.createElement(HeaderComponentContainer, null, React__default.createElement(HeaderComponent, {
    onClickMenuIcon: onClickMenuIcon,
    onClickUserIcon: onClickUserIcon,
    user: user
  })), React__default.createElement(ContentComponentContainer, null, React__default.createElement(Router, {
    history: history
  }, React__default.createElement(Switch, null, children, React__default.createElement(Redirect, {
    from: "/login",
    to: "/",
    exact: true
  }), React__default.createElement(Route$1, {
    render: function render() {
      return React__default.createElement("div", null, "Not Found!");
    }
  })))), React__default.createElement(FooterComponentContainer, null, React__default.createElement(FooterComponent, null)));
};

var Container$2 = styled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: center;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: center;\n"])));
var templateObject_1$f;
var Header$2 = styled.div(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n    flex: 1;\n"], ["\n    flex: 1;\n"])));
var templateObject_1$g;
var CMSFieldTitle = styled.label(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n    font-size: 14pt;\n    text-align: left;\n    margin-bottom: 5px;\n    color: ", ";\n"], ["\n    font-size: 14pt;\n    text-align: left;\n    margin-bottom: 5px;\n    color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.input.titleTextColor;
});
var templateObject_1$h;
var CMSFieldMessage = styled.span(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n    margin-top: 5px;\n    font-size: 8pt;\n    text-align: left;\n    color: ", ";\n"], ["\n    margin-top: 5px;\n    font-size: 8pt;\n    text-align: left;\n    color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.input.messageTextColor;
});
var templateObject_1$i;
var Container$3 = styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    overflow: hidden;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    \n    margin-top: 10px;\n    margin-bottom: 10px;\n"], ["\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    overflow: hidden;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    \n    margin-top: 10px;\n    margin-bottom: 10px;\n"])));
var InputContainer = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: flex;\n    border-style: solid;\n    border-width: 1px;\n    border-color: ", ";\n    border-radius: 5px;\n    width: 100%;\n    overflow: hidden;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    background-color: ", ";\n"], ["\n    box-sizing: border-box;\n    display: flex;\n    border-style: solid;\n    border-width: 1px;\n    border-color: ", ";\n    border-radius: 5px;\n    width: 100%;\n    overflow: hidden;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    background-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.input.borderColor;
}, function (_a) {
  var theme = _a.theme;
  return theme.input.backgroundColor;
});

var CMSField = function CMSField(_a) {
  var _b = _a.theme,
      theme = _b === void 0 ? CMSDefaultTheme : _b,
      className = _a.className,
      title = _a.title,
      message = _a.message,
      renderInput = _a.renderInput,
      containerProps = _a.containerProps,
      titleProps = _a.titleProps,
      messageProps = _a.messageProps,
      props = __rest(_a, ["theme", "className", "title", "message", "renderInput", "containerProps", "titleProps", "messageProps"]);

  return createElement(ThemeProvider, {
    theme: theme
  }, createElement(Container$3, {
    className: className
  }, title && createElement(CMSFieldTitle, _assign({
    htmlFor: props.id,
    className: "Title"
  }, titleProps), title), createElement(InputContainer, _assign({
    className: "InputContainer"
  }, containerProps), renderInput(props)), message && createElement(CMSFieldMessage, _assign({
    className: "Message"
  }, messageProps), message)));
};

var templateObject_1$j, templateObject_2$4;
var Input = styled.input(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n    appearance: none;\n    box-sizing: border-box;\n    flex: 1;\n    font-size: 14pt;\n    border-width: 0px;\n    height: 35px;\n    color: ", ";\n"], ["\n    appearance: none;\n    box-sizing: border-box;\n    flex: 1;\n    font-size: 14pt;\n    border-width: 0px;\n    height: 35px;\n    color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.input.textColor;
});

var CMSTextField = function CMSTextField(props) {
  var _a = props.theme,
      theme = _a === void 0 ? CMSDefaultTheme : _a;
  return createElement(ThemeProvider, {
    theme: theme
  }, createElement(CMSField, _assign({}, props, {
    renderInput: function renderInput(renderProps) {
      return createElement(Input, _assign({
        className: "Input",
        type: renderProps.password ? 'password' : undefined
      }, renderProps));
    }
  })));
};

var templateObject_1$k;
var Button = styled.div(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: ", ";\n    border-radius: 5px;\n    height: 44px;\n    :hover {\n        cursor: pointer;\n    }\n    :active {\n        background-color: ", ";\n        \n        span {\n            color: ", ";    \n        }\n    }\n    margin-top: 20px;\n    margin-bottom: 10px;\n"], ["\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: ", ";\n    border-radius: 5px;\n    height: 44px;\n    :hover {\n        cursor: pointer;\n    }\n    :active {\n        background-color: ", ";\n        \n        span {\n            color: ", ";    \n        }\n    }\n    margin-top: 20px;\n    margin-bottom: 10px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.button.backgroundColor;
}, function (_a) {
  var theme = _a.theme;
  return theme.button.activeBackgroundColor;
}, function (_a) {
  var theme = _a.theme;
  return theme.button.activeTitleColor;
});
var ButtonTitle = styled.span(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n    font-size: 14pt;\n    border-width: 0px;\n    color: ", ";\n    user-select: none;\n"], ["\n    font-size: 14pt;\n    border-width: 0px;\n    color: ", ";\n    user-select: none;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.button.titleColor;
});

var CMSButton = function CMSButton(_a) {
  var className = _a.className,
      title = _a.title,
      onClick = _a.onClick,
      _b = _a.theme,
      theme = _b === void 0 ? CMSDefaultTheme : _b;
  return createElement(ThemeProvider, {
    theme: theme
  }, createElement(Button, {
    className: className,
    onClick: onClick
  }, createElement(ButtonTitle, {
    className: "Title"
  }, title)));
};

var templateObject_1$l, templateObject_2$5;
var Container$4 = styled.div(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    overflow: hidden;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    justify-content: center;\n"], ["\n    box-sizing: border-box;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    overflow: hidden;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    justify-content: center;\n"])));
var TitleCheckboxContainer = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: ", ";\n    width: 100%;\n    overflow: hidden;\n    align-items: center;\n    justify-content: ", ";\n"], ["\n    display: flex;\n    flex-direction: ", ";\n    width: 100%;\n    overflow: hidden;\n    align-items: center;\n    justify-content: ", ";\n"])), function (_a) {
  var reversed = _a.reversed;
  return reversed ? 'row-reverse' : 'row';
}, function (_a) {
  var reversed = _a.reversed;
  return reversed ? 'flex-end' : 'flex-start';
});
var Input$1 = styled.input(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n    margin-top: 0px;\n    margin-bottom: 0px;\n"], ["\n    margin-top: 0px;\n    margin-bottom: 0px;\n"])));
var Title = styled(CMSFieldTitle)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 10pt;\n    margin-left: 5px;\n    margin-right: 5px;\n"], ["\n    font-size: 10pt;\n    margin-left: 5px;\n    margin-right: 5px;\n"])));

var CMSCheckbox = function CMSCheckbox(_a) {
  var _b = _a.theme,
      theme = _b === void 0 ? CMSDefaultTheme : _b,
      className = _a.className,
      title = _a.title,
      message = _a.message,
      _c = _a.reversed,
      reversed = _c === void 0 ? true : _c,
      _d = _a.value,
      value = _d === void 0 ? false : _d,
      props = __rest(_a, ["theme", "className", "title", "message", "reversed", "value"]);

  return createElement(ThemeProvider, {
    theme: theme
  }, createElement(Container$4, {
    className: className
  }, createElement(TitleCheckboxContainer, {
    className: "TitleCheckboxContainer",
    reversed: reversed
  }, title && createElement(Title, {
    htmlFor: props.id,
    className: "Title"
  }, title), createElement(Input$1, _assign({
    className: "Input",
    type: 'checkbox',
    checked: value
  }, props))), message && createElement(CMSFieldMessage, {
    className: "Message"
  }, message)));
};

var templateObject_1$m, templateObject_2$6, templateObject_3$2, templateObject_4;
var CMSTitle = styled.h1(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n    font-size: 14pt;\n    text-align: left;\n    margin-bottom: 5px;\n    color: ", ";\n"], ["\n    font-size: 14pt;\n    text-align: left;\n    margin-bottom: 5px;\n    color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.input.titleTextColor;
});
var templateObject_1$n;
var FIELD_TYPES = [CMSCheckbox, CMSTextField];

var applyPropsToChildren = function applyPropsToChildren(children, onChange, values) {
  if (values === void 0) {
    values = {};
  }

  return Children.map(children, function (child) {
    var newProps = {
      children: applyPropsToChildren(child.props.children, onChange, values)
    };

    if (FIELD_TYPES.includes(child.type) || FIELD_TYPES.includes(child.type.protoype)) {
      var id = child.props.id;

      if (!id) {
        return;
      }

      newProps.value = values[id] || "";
      newProps.onChange = onChange;
    }

    return cloneElement(child, _assign({}, child.props, newProps));
  });
};

var CMSFieldContainer =
/** @class */
function (_super) {
  __extends(CMSFieldContainer, _super);

  function CMSFieldContainer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {};

    _this.onChange = function (event) {
      var _a;

      var target = event.target;

      if (!target.id) {
        return;
      }

      var value = target.type === 'checkbox' ? target.checked : target.value;
      var data = _this.props.data || {};

      var onChange = _this.props.onChange || function () {
        return null;
      };

      onChange(_assign({}, data, (_a = {}, _a[target.id] = value, _a)));
    };

    return _this;
  }

  CMSFieldContainer.prototype.render = function () {
    var data = this.props.data || {};
    var defaultChildren = this.props.children;
    var children = applyPropsToChildren(defaultChildren, this.onChange, data);
    return createElement("div", {
      className: this.props.className
    }, children);
  };

  return CMSFieldContainer;
}(Component);

var defaults = {
  lines: 12,
  length: 7,
  width: 5,
  radius: 10,
  scale: 1.0,
  corners: 1,
  color: '#000',
  fadeColor: 'transparent',
  animation: 'spinner-line-fade-default',
  rotate: 0,
  direction: 1,
  speed: 1,
  zIndex: 2e9,
  className: 'spinner',
  top: '50%',
  left: '50%',
  shadow: '0 0 1px transparent',
  position: 'absolute'
};

var Spinner =
/** @class */
function () {
  function Spinner(opts) {
    if (opts === void 0) {
      opts = {};
    }

    this.opts = _assign({}, defaults, opts);
  }
  /**
   * Adds the spinner to the given target element. If this instance is already
   * spinning, it is automatically removed from its previous target by calling
   * stop() internally.
   */


  Spinner.prototype.spin = function (target) {
    this.stop();
    this.el = document.createElement('div');
    this.el.className = this.opts.className;
    this.el.setAttribute('role', 'progressbar');
    css(this.el, {
      position: this.opts.position,
      width: 0,
      zIndex: this.opts.zIndex,
      left: this.opts.left,
      top: this.opts.top,
      transform: "scale(" + this.opts.scale + ")"
    });

    if (target) {
      target.insertBefore(this.el, target.firstChild || null);
    }

    drawLines(this.el, this.opts);
    return this;
  };
  /**
   * Stops and removes the Spinner.
   * Stopped spinners may be reused by calling spin() again.
   */


  Spinner.prototype.stop = function () {
    if (this.el) {
      if (typeof requestAnimationFrame !== 'undefined') {
        cancelAnimationFrame(this.animateId);
      } else {
        clearTimeout(this.animateId);
      }

      if (this.el.parentNode) {
        this.el.parentNode.removeChild(this.el);
      }

      this.el = undefined;
    }

    return this;
  };

  return Spinner;
}();
/**
 * Sets multiple style properties at once.
 */


function css(el, props) {
  for (var prop in props) {
    el.style[prop] = props[prop];
  }

  return el;
}
/**
 * Returns the line color from the given string or array.
 */


function getColor(color, idx) {
  return typeof color == 'string' ? color : color[idx % color.length];
}
/**
 * Internal method that draws the individual lines.
 */


function drawLines(el, opts) {
  var borderRadius = Math.round(opts.corners || 1 * (opts.width || 1) * 500) / 1000 + 'px';
  var shadow = 'none';

  if (opts.shadow === true) {
    shadow = '0 2px 4px #000'; // default shadow
  } else if (typeof opts.shadow === 'string') {
    shadow = opts.shadow;
  }

  var shadows = parseBoxShadow(shadow);

  for (var i = 0; i < (opts.lines || 0); i++) {
    var degrees = ~~(360 / (opts.lines || 0) * i + (opts.rotate || 0));
    var backgroundLine = css(document.createElement('div'), {
      position: 'absolute',
      top: -(opts.width || 0) / 2 + "px",
      width: (opts.length || 0) + (opts.width || 0) + 'px',
      height: opts.width + 'px',
      background: getColor(opts.fadeColor || '', i),
      borderRadius: borderRadius,
      transformOrigin: 'left',
      transform: "rotate(" + degrees + "deg) translateX(" + opts.radius + "px)"
    });
    var delay = i * (opts.direction || 0) / (opts.lines || 1) / (opts.speed || 1);
    delay -= 1 / (opts.speed || 1); // so initial animation state will include trail

    var line = css(document.createElement('div'), {
      width: '100%',
      height: '100%',
      background: getColor(opts.color || '', i),
      borderRadius: borderRadius,
      boxShadow: normalizeShadow(shadows, degrees),
      animation: 1 / (opts.speed || 1) + "s linear " + delay + "s infinite " + opts.animation
    });
    backgroundLine.appendChild(line);
    el.appendChild(backgroundLine);
  }
}

function parseBoxShadow(boxShadow) {
  var regex = /^\s*([a-zA-Z]+\s+)?(-?\d+(\.\d+)?)([a-zA-Z]*)\s+(-?\d+(\.\d+)?)([a-zA-Z]*)(.*)$/;
  var shadows = [];

  for (var _i = 0, _a = boxShadow.split(','); _i < _a.length; _i++) {
    var shadow = _a[_i];
    var matches = shadow.match(regex);

    if (matches === null) {
      continue; // invalid syntax
    }

    var x = +matches[2];
    var y = +matches[5];
    var xUnits = matches[4];
    var yUnits = matches[7];

    if (x === 0 && !xUnits) {
      xUnits = yUnits;
    }

    if (y === 0 && !yUnits) {
      yUnits = xUnits;
    }

    if (xUnits !== yUnits) {
      continue; // units must match to use as coordinates
    }

    shadows.push({
      prefix: matches[1] || '',
      x: x,
      y: y,
      xUnits: xUnits,
      yUnits: yUnits,
      end: matches[8]
    });
  }

  return shadows;
}
/**
 * Modify box-shadow x/y offsets to counteract rotation
 */


function normalizeShadow(shadows, degrees) {
  var normalized = [];

  for (var _i = 0, shadows_1 = shadows; _i < shadows_1.length; _i++) {
    var shadow = shadows_1[_i];
    var xy = convertOffset(shadow.x, shadow.y, degrees);
    normalized.push(shadow.prefix + xy[0] + shadow.xUnits + ' ' + xy[1] + shadow.yUnits + shadow.end);
  }

  return normalized.join(', ');
}

function convertOffset(x, y, degrees) {
  var radians = degrees * Math.PI / 180;
  var sin = Math.sin(radians);
  var cos = Math.cos(radians);
  return [Math.round((x * cos + y * sin) * 1000) / 1000, Math.round((-x * sin + y * cos) * 1000) / 1000];
}

var SpinnerLineFadeDefaultAnimation = function SpinnerLineFadeDefaultAnimation(color) {
  return keyframes(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n    0%, 100% {\n      opacity: 0.22;\n      background-color: ", ";\n    }\n    1% {\n      opacity: 1;\n      background-color: ", ";\n    }\n"], ["\n    0%, 100% {\n      opacity: 0.22;\n      background-color: ", ";\n    }\n    1% {\n      opacity: 1;\n      background-color: ", ";\n    }\n"])), color, color);
};

var templateObject_1$o;
var loadingAnimationName;
var Container$5 = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject([" \n    animation: ", "; \n"], [" \n    animation: ", "; \n"])), function (_a) {
  var theme = _a.theme;
  var animation = SpinnerLineFadeDefaultAnimation(theme.loader.color || 'black');

  if (!loadingAnimationName) {
    loadingAnimationName = animation.getName();
  }

  return animation;
});

var CMSLoader =
/** @class */
function (_super) {
  __extends(CMSLoader, _super);

  function CMSLoader() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.update = function () {
      var spinner = new Spinner(_assign({}, _this.props, {
        animation: loadingAnimationName,
        radius: 5,
        width: 2,
        length: 5
      }));
      var target = ReactDom.findDOMNode(_this.loader);

      if (target) {
        target.innerHTML = '';
      }

      if (_this.props.animating) {
        spinner.spin(target);
      }
    };

    return _this;
  }

  CMSLoader.prototype.componentDidMount = function () {
    this.update();
  };

  CMSLoader.prototype.componentDidUpdate = function () {
    this.update();
  };

  CMSLoader.prototype.render = function () {
    var _this = this;

    return React__default.createElement(ThemeProvider, {
      theme: this.props.theme || CMSDefaultTheme
    }, React__default.createElement(Container$5, {
      className: "Loader",
      ref: function ref(r) {
        return _this.loader = r;
      }
    }));
  };

  return CMSLoader;
}(Component);

var templateObject_1$p;
var FormContainer = styled.form(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    box-sizing: border-box;\n    padding: 15px;\n    align-items: center;\n    justify-content: center;\n"], ["\n    display: flex;\n    flex-direction: row;\n    box-sizing: border-box;\n    padding: 15px;\n    align-items: center;\n    justify-content: center;\n"])));
var InnerContainer = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    box-sizing: border-box;\n    padding: 15px;\n    max-width: 480px;  \n    min-height: 380px;\n    position: relative;\n"], ["\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    box-sizing: border-box;\n    padding: 15px;\n    max-width: 480px;  \n    min-height: 380px;\n    position: relative;\n"])));
var OptionsContainer = styled.div(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n    @media (max-width: 320px) {\n        flex-direction: column;\n    }\n"], ["\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n    @media (max-width: 320px) {\n        flex-direction: column;\n    }\n"])));
var Link = styled(CMSButton)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n    flex: 0;\n    background-color: white;\n    justify-content: flex-start;\n    height: 30px;\n    :active {\n        background-color: white;\n    }\n    .Title {\n        color: ", ";\n        text-align: left;\n        font-size: 10pt;\n        white-space: nowrap;\n        :active {\n            color: ", ";\n        }\n    }\n"], ["\n    flex: 0;\n    background-color: white;\n    justify-content: flex-start;\n    height: 30px;\n    :active {\n        background-color: white;\n    }\n    .Title {\n        color: ", ";\n        text-align: left;\n        font-size: 10pt;\n        white-space: nowrap;\n        :active {\n            color: ", ";\n        }\n    }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.button.activeBackgroundColor;
}, function (_a) {
  var theme = _a.theme;
  return theme.button.backgroundColor;
});
var ErrorMessage = styled.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: 10px;\n    border: 1px solid red;\n    border-radius: 5px;\n    color: red;\n    background: rgba(255,0,0,0.1);\n    line-height: 150%;\n"], ["\n    padding: 10px;\n    border: 1px solid red;\n    border-radius: 5px;\n    color: red;\n    background: rgba(255,0,0,0.1);\n    line-height: 150%;\n"])));
var FieldContainer = styled(CMSFieldContainer)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    pointer-events: ", ";\n    opacity:  ", ";\n"], ["\n    pointer-events: ", ";\n    opacity:  ", ";\n"])), function (_a) {
  var _b = _a.loading,
      loading = _b === void 0 ? false : _b;
  return loading ? 'none' : 'initial';
}, function (_a) {
  var _b = _a.loading,
      loading = _b === void 0 ? false : _b;
  return loading ? '0.5' : '1';
});

var Form = function Form(props) {
  var _a = props.title,
      title = _a === void 0 ? "Login" : _a,
      onClickLogin = props.onClickLogin,
      onChange = props.onChange,
      onClickForgotPassword = props.onClickForgotPassword,
      onClickSignUp = props.onClickSignUp,
      _b = props.loading,
      loading = _b === void 0 ? false : _b,
      errorMessage = props.errorMessage,
      otherProps = __rest(props, ["title", "onClickLogin", "onChange", "onClickForgotPassword", "onClickSignUp", "loading", "errorMessage"]);

  return React__default.createElement(FormContainer, {
    className: "FormContainer"
  }, React__default.createElement(InnerContainer, {
    className: "InnerContainer"
  }, loading && React__default.createElement(CMSLoader, {
    animating: true
  }), React__default.createElement(CMSTitle, {
    className: "Title"
  }, title), errorMessage && React__default.createElement(ErrorMessage, {
    className: "ErrorMessage"
  }, errorMessage), React__default.createElement(FieldContainer, {
    data: otherProps,
    onChange: onChange,
    loading: loading,
    className: "FieldContainer"
  }, React__default.createElement(CMSTextField, {
    id: "email",
    title: "Email",
    className: "Email TextField"
  }), React__default.createElement(CMSTextField, {
    id: "password",
    title: "Password",
    password: true,
    className: "Password TextField"
  }), React__default.createElement(OptionsContainer, {
    className: "OptionsContainer"
  }, React__default.createElement(CMSCheckbox, {
    id: "rememberMe",
    title: "Remember Me",
    className: "RememberMe Checkbox"
  }), React__default.createElement(Link, {
    title: "Forgot password?",
    onClick: onClickForgotPassword,
    className: "ForgotPassword Link"
  })), React__default.createElement(CMSButton, {
    title: "Login",
    onClick: onClickLogin,
    className: "Login Button"
  })), React__default.createElement(OptionsContainer, null, React__default.createElement(Link, {
    title: "Create an account",
    onClick: onClickSignUp,
    className: "CreateAccount Link"
  }))));
};

var templateObject_1$q, templateObject_2$7, templateObject_3$3, templateObject_4$1, templateObject_5, templateObject_6;

var CMSLogin =
/** @class */
function (_super) {
  __extends(CMSLogin, _super);

  function CMSLogin() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      formData: {},
      loading: false
    };

    _this.onChangeForm = function (formData) {
      _this.setState({
        formData: formData
      });
    };

    _this.onClickLogin = function (_) {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, _b, onSignIn, _c, onSignInCompleted, _d, _e, email, _f, password, error_1;

        return __generator(this, function (_g) {
          switch (_g.label) {
            case 0:
              _a = this.props, _b = _a.onSignIn, onSignIn = _b === void 0 ? function () {
                return null;
              } : _b, _c = _a.onSignInCompleted, onSignInCompleted = _c === void 0 ? function () {
                return null;
              } : _c;
              _d = this.state.formData || {}, _e = _d.email, email = _e === void 0 ? '' : _e, _f = _d.password, password = _f === void 0 ? '' : _f;
              this.setState({
                loading: true
              });
              _g.label = 1;

            case 1:
              _g.trys.push([1, 3,, 4]);

              return [4
              /*yield*/
              , onSignIn(email, password)];

            case 2:
              _g.sent();

              onSignInCompleted();
              return [3
              /*break*/
              , 4];

            case 3:
              error_1 = _g.sent();
              console.error(error_1);
              this.setState({
                errorMessage: error_1.message,
                loading: false
              });
              return [3
              /*break*/
              , 4];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    return _this;
  }

  CMSLogin.prototype.render = function () {
    var _a = this.props,
        _b = _a.theme,
        theme = _b === void 0 ? CMSDefaultTheme : _b,
        className = _a.className,
        title = _a.title,
        _c = _a.HeaderComponent,
        HeaderComponent = _c === void 0 ? Header$2 : _c,
        _d = _a.FooterComponent,
        FooterComponent = _d === void 0 ? function () {
      return null;
    } : _d,
        _e = _a.ContentComponent,
        ContentComponent = _e === void 0 ? Form : _e,
        onClickSignUp = _a.onClickSignUp,
        onClickForgotPassword = _a.onClickForgotPassword;
    var _f = this.state,
        formData = _f.formData,
        loading = _f.loading,
        errorMessage = _f.errorMessage;
    return createElement(ThemeProvider, {
      theme: theme
    }, createElement(Container$2, {
      className: className + " Login"
    }, createElement(HeaderComponent, {
      className: "Header"
    }), createElement(ContentComponent, _assign({
      loading: loading,
      title: title,
      onChange: this.onChangeForm,
      onClickLogin: this.onClickLogin,
      onClickSignUp: onClickSignUp,
      onClickForgotPassword: onClickForgotPassword,
      errorMessage: errorMessage
    }, formData)), createElement(FooterComponent, {
      className: "Footer"
    })));
  };

  return CMSLogin;
}(Component);

var Form$1 = function Form$1(props) {
  var _a = props.title,
      title = _a === void 0 ? "Sign Up" : _a,
      onClickSignUp = props.onClickSignUp,
      onChange = props.onChange,
      onClickCancel = props.onClickCancel,
      _b = props.loading,
      loading = _b === void 0 ? false : _b,
      errorMessage = props.errorMessage,
      otherProps = __rest(props, ["title", "onClickSignUp", "onChange", "onClickCancel", "loading", "errorMessage"]);

  return React__default.createElement(FormContainer, {
    className: "FormContainer"
  }, React__default.createElement(InnerContainer, {
    className: "InnerContainer"
  }, loading && React__default.createElement(CMSLoader, {
    animating: true
  }), React__default.createElement(CMSTitle, {
    className: "Title"
  }, title), errorMessage && React__default.createElement(ErrorMessage, {
    className: "ErrorMessage"
  }, errorMessage), React__default.createElement(FieldContainer, {
    data: otherProps,
    onChange: onChange,
    loading: loading,
    className: "FieldContainer"
  }, React__default.createElement(CMSTextField, {
    id: "email",
    title: "Email",
    className: "Email TextField"
  }), React__default.createElement(CMSTextField, {
    id: "password",
    title: "Password",
    password: true,
    className: "Password TextField"
  }), React__default.createElement(CMSTextField, {
    id: "confirmPassword",
    title: "Confirm Password",
    password: true,
    className: "ConfirmPassword TextField"
  }), React__default.createElement(CMSButton, {
    title: "Sign Up!",
    onClick: onClickSignUp,
    className: "SignUp Button"
  })), React__default.createElement(OptionsContainer, {
    className: "OptionsContainer"
  }, React__default.createElement(Link, {
    title: "Cancel",
    onClick: onClickCancel,
    className: "Cancel Link"
  }))));
};

var CMSSignUp =
/** @class */
function (_super) {
  __extends(CMSSignUp, _super);

  function CMSSignUp() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      formData: {},
      loading: false
    };

    _this.onChangeForm = function (formData) {
      _this.setState({
        formData: formData
      });
    };

    _this.onClickSignUp = function (_) {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, _b, onSignUp, _c, onSignUpCompleted, _d, _e, email, _f, password, _g, confirmPassword, error_1;

        return __generator(this, function (_h) {
          switch (_h.label) {
            case 0:
              _a = this.props, _b = _a.onSignUp, onSignUp = _b === void 0 ? function () {
                return null;
              } : _b, _c = _a.onSignUpCompleted, onSignUpCompleted = _c === void 0 ? function () {
                return null;
              } : _c;
              _d = this.state.formData || {}, _e = _d.email, email = _e === void 0 ? '' : _e, _f = _d.password, password = _f === void 0 ? '' : _f, _g = _d.confirmPassword, confirmPassword = _g === void 0 ? '' : _g;
              this.setState({
                loading: true
              });
              _h.label = 1;

            case 1:
              _h.trys.push([1, 5,, 6]);

              if (!(confirmPassword === password)) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , onSignUp(email, password)];

            case 2:
              _h.sent();

              onSignUpCompleted();
              return [3
              /*break*/
              , 4];

            case 3:
              throw new Error("Password does not match it's confirmation.");

            case 4:
              return [3
              /*break*/
              , 6];

            case 5:
              error_1 = _h.sent();
              console.error(error_1);
              this.setState({
                errorMessage: error_1.message,
                loading: false
              });
              return [3
              /*break*/
              , 6];

            case 6:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    return _this;
  }

  CMSSignUp.prototype.render = function () {
    var _a = this.props,
        _b = _a.theme,
        theme = _b === void 0 ? CMSDefaultTheme : _b,
        className = _a.className,
        title = _a.title,
        _c = _a.HeaderComponent,
        HeaderComponent = _c === void 0 ? Header$2 : _c,
        _d = _a.FooterComponent,
        FooterComponent = _d === void 0 ? function () {
      return null;
    } : _d,
        _e = _a.ContentComponent,
        ContentComponent = _e === void 0 ? Form$1 : _e,
        _f = _a.onClickCancel,
        onClickCancel = _f === void 0 ? function () {
      return null;
    } : _f;
    var _g = this.state,
        formData = _g.formData,
        loading = _g.loading,
        errorMessage = _g.errorMessage;
    return createElement(ThemeProvider, {
      theme: theme
    }, createElement(Container$2, {
      className: className + " SignUp"
    }, createElement(HeaderComponent, {
      className: "Header"
    }), createElement(ContentComponent, _assign({
      loading: loading,
      title: title,
      onChange: this.onChangeForm,
      onClickSignUp: this.onClickSignUp,
      onClickCancel: onClickCancel,
      errorMessage: errorMessage
    }, formData)), createElement(FooterComponent, {
      className: "Footer"
    })));
  };

  return CMSSignUp;
}(Component);

var HeaderContainer$1 = styled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    width: 100%;\n    height: 85px;\n    padding: 10px;\n    overflow: hidden;\n    box-sizing: border-box;\n    border-bottom: 0.4pt solid ", ";\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    width: 100%;\n    height: 85px;\n    padding: 10px;\n    overflow: hidden;\n    box-sizing: border-box;\n    border-bottom: 0.4pt solid ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.authMenu.rowSeperatorColor;
});
var TitleContainer = styled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n"])));
var DisplayNameTitle = styled.span(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n    color: ", " ;\n    font-size: 12pt;\n    font-weight: bold;\n"], ["\n    color: ", " ;\n    font-size: 12pt;\n    font-weight: bold;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.authMenu.defaultTextColor;
});
var EmailTitle = styled.span(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n    margin-top: 5px;\n    color: ", " ;\n    font-size: 9pt;\n"], ["\n    margin-top: 5px;\n    color: ", " ;\n    font-size: 9pt;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.authMenu.defaultTextColor;
});
var Avatar = styled(CMSAvatar)(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n    width: 60px;\n    height: 60px;\n    margin-right: 10px;\n    color: ", ";\n"], ["\n    width: 60px;\n    height: 60px;\n    margin-right: 10px;\n    color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.authMenu.defaultTextColor;
});

var Header$3 = function Header$3(_a) {
  var photoURL = _a.photoURL,
      displayName = _a.displayName,
      email = _a.email;
  return createElement(HeaderContainer$1, null, createElement(Avatar, {
    photoURL: photoURL
  }), createElement(TitleContainer, null, createElement(DisplayNameTitle, null, displayName || "User"), createElement(EmailTitle, null, email)));
};

var templateObject_1$r, templateObject_2$8, templateObject_3$4, templateObject_4$2, templateObject_5$1;
var Menu$1 = styled.div(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: calc(", " + 5px);\n    @media (max-width: ", ") {\n        top: calc(", " + 5px);\n    }\n    right: 15px;\n    width: 280px;\n    min-height: 100px;\n    max-height: 320px;\n    overflow: scroll;\n    background-color: white;\n    border-style: solid;\n    border-color: lightgrey;\n    border-width: 1px;\n    box-shadow: 1px 1px 5px grey;\n    border-radius: 5px;\n    opacity: ", ";\n    transition: opacity 300ms;\n"], ["\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: calc(", " + 5px);\n    @media (max-width: ", ") {\n        top: calc(", " + 5px);\n    }\n    right: 15px;\n    width: 280px;\n    min-height: 100px;\n    max-height: 320px;\n    overflow: scroll;\n    background-color: white;\n    border-style: solid;\n    border-color: lightgrey;\n    border-width: 1px;\n    box-shadow: 1px 1px 5px grey;\n    border-radius: 5px;\n    opacity: ", ";\n    transition: opacity 300ms;\n"])), function (_a) {
  var t = _a.theme;
  return t.header.desktopHeight;
}, function (_a) {
  var t = _a.theme;
  return t.mobileWidthBoundry;
}, function (_a) {
  var t = _a.theme;
  return t.header.mobileHeight;
}, function (_a) {
  var visible = _a.visible;
  return visible ? '1' : '0';
});
var templateObject_1$s;
var MenuItemContainer$1 = styled.div(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    width: 100%;\n    height: 44px;\n    padding: 12px 15px 12px 15px;\n    overflow: hidden;\n    box-sizing: border-box;\n    ", "\n    transition: 300ms;\n    :hover {\n        background-color: ", "; \n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    width: 100%;\n    height: 44px;\n    padding: 12px 15px 12px 15px;\n    overflow: hidden;\n    box-sizing: border-box;\n    ", "\n    transition: 300ms;\n    :hover {\n        background-color: ", "; \n    }\n"])), function (_a) {
  var seperator = _a.seperator,
      theme = _a.theme;
  return seperator ? "border-bottom: 0.4pt solid " + theme.authMenu.rowSeperatorColor + ";" : '';
}, function (_a) {
  var theme = _a.theme;
  return theme.authMenu.selectedBackgroundColor;
});
var ItemTitle$1 = styled.span(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 12pt;\n    font-weight: ", ";\n"], ["\n    color: ", ";\n    font-size: 12pt;\n    font-weight: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.authMenu.defaultTextColor;
}, function (_a) {
  var selected = _a.selected;
  return selected ? 'bold' : '300';
});

var MenuItem$1 = function MenuItem$1(props) {
  var title = props.title,
      _a = props.onClick,
      _onClick2 = _a === void 0 ? function () {
    return null;
  } : _a,
      _b = props.selected,
      selected = _b === void 0 ? false : _b,
      _c = props.seperator,
      seperator = _c === void 0 ? false : _c;

  return createElement(MenuItemContainer$1, {
    onClick: function onClick(event) {
      _onClick2(props);

      event.preventDefault();
    },
    seperator: seperator
  }, createElement(ItemTitle$1, {
    selected: selected
  }, title));
};

var templateObject_1$t, templateObject_2$9;
var Container$6 = styled.div(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n    position: relative;\n    width: 100vw;\n    height: 100vh;\n"], ["\n    position: relative;\n    width: 100vw;\n    height: 100vh;\n"])));

var CMSAccountMenu =
/** @class */
function (_super) {
  __extends(CMSAccountMenu, _super);

  function CMSAccountMenu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onClickBackground = function (event) {
      var _a = _this.props.onDismiss,
          onDismiss = _a === void 0 ? function () {
        return null;
      } : _a;
      onDismiss(event);
      return event;
    };

    _this.onClick = function (event) {
      event.stopPropagation();
    };

    return _this;
  }

  CMSAccountMenu.prototype.render = function () {
    var _a = this.props,
        _b = _a.theme,
        theme = _b === void 0 ? CMSDefaultTheme : _b,
        _c = _a.visible,
        visible = _c === void 0 ? false : _c,
        user = _a.user,
        onClickShowAccountSettings = _a.onClickShowAccountSettings,
        onClickSignOut = _a.onClickSignOut;
    return createElement(ThemeProvider, {
      theme: theme
    }, createElement(Container$6, {
      onClick: this.onClickBackground
    }, createElement(Menu$1, {
      visible: visible,
      onClick: this.onClick
    }, createElement(Header$3, {
      displayName: user ? user.displayName : undefined,
      email: user ? user.email : undefined,
      photoURL: user ? user.photoURL : undefined
    }), createElement(MenuItem$1, {
      title: "Account Settings",
      seperator: true,
      onClick: onClickShowAccountSettings
    }), createElement(MenuItem$1, {
      title: "Sign Out",
      onClick: onClickSignOut
    }))));
  };

  return CMSAccountMenu;
}(Component);

var templateObject_1$u;

var Form$2 = function Form$2(props) {
  var _a = props.title,
      title = _a === void 0 ? "Forgot Password" : _a,
      onClickForgotPassword = props.onClickForgotPassword,
      onChange = props.onChange,
      onClickCancel = props.onClickCancel,
      _b = props.loading,
      loading = _b === void 0 ? false : _b,
      errorMessage = props.errorMessage,
      otherProps = __rest(props, ["title", "onClickForgotPassword", "onChange", "onClickCancel", "loading", "errorMessage"]);

  return React__default.createElement(FormContainer, {
    className: "FormContainer"
  }, React__default.createElement(InnerContainer, {
    className: "InnerContainer"
  }, loading && React__default.createElement(CMSLoader, {
    animating: true
  }), React__default.createElement(CMSTitle, {
    className: "Title"
  }, title), errorMessage && React__default.createElement(ErrorMessage, {
    className: "ErrorMessage"
  }, errorMessage), React__default.createElement(FieldContainer, {
    data: otherProps,
    onChange: onChange,
    loading: loading,
    className: "FieldContainer"
  }, React__default.createElement(CMSTextField, {
    id: "email",
    title: "Email",
    className: "Email TextField"
  }), React__default.createElement(CMSButton, {
    title: "Reset Password",
    onClick: onClickForgotPassword,
    className: "ResetPassword Button"
  })), React__default.createElement(OptionsContainer, {
    className: "OptionsContainer"
  }, React__default.createElement(Link, {
    title: "Cancel",
    onClick: onClickCancel,
    className: "Cancel Link"
  }))));
};

var CMSForgotPassword =
/** @class */
function (_super) {
  __extends(CMSForgotPassword, _super);

  function CMSForgotPassword() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      formData: {},
      loading: false
    };

    _this.onChangeForm = function (formData) {
      _this.setState({
        formData: formData
      });
    };

    _this.onClickForgotPassword = function (_) {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, _b, onForgotPassword, _c, onForgotPasswordCompleted, _d, email, error_1;

        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              _a = this.props, _b = _a.onForgotPassword, onForgotPassword = _b === void 0 ? function () {
                return null;
              } : _b, _c = _a.onForgotPasswordCompleted, onForgotPasswordCompleted = _c === void 0 ? function () {
                return null;
              } : _c;
              _d = (this.state.formData || {}).email, email = _d === void 0 ? '' : _d;
              this.setState({
                loading: true
              });
              _e.label = 1;

            case 1:
              _e.trys.push([1, 3,, 4]);

              return [4
              /*yield*/
              , onForgotPassword(email)];

            case 2:
              _e.sent();

              onForgotPasswordCompleted();
              return [3
              /*break*/
              , 4];

            case 3:
              error_1 = _e.sent();
              console.error(error_1);
              this.setState({
                errorMessage: error_1.message,
                loading: false
              });
              return [3
              /*break*/
              , 4];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    return _this;
  }

  CMSForgotPassword.prototype.render = function () {
    var _a = this.props,
        _b = _a.theme,
        theme = _b === void 0 ? CMSDefaultTheme : _b,
        className = _a.className,
        title = _a.title,
        _c = _a.HeaderComponent,
        HeaderComponent = _c === void 0 ? Header$2 : _c,
        _d = _a.FooterComponent,
        FooterComponent = _d === void 0 ? function () {
      return null;
    } : _d,
        _e = _a.ContentComponent,
        ContentComponent = _e === void 0 ? Form$2 : _e,
        _f = _a.onClickCancel,
        onClickCancel = _f === void 0 ? function () {
      return null;
    } : _f;
    var _g = this.state,
        formData = _g.formData,
        loading = _g.loading,
        errorMessage = _g.errorMessage;
    return createElement(ThemeProvider, {
      theme: theme
    }, createElement(Container$2, {
      className: className + " ForgotPassword"
    }, createElement(HeaderComponent, {
      className: "Header"
    }), createElement(ContentComponent, _assign({
      loading: loading,
      title: title,
      onChange: this.onChangeForm,
      onClickForgotPassword: this.onClickForgotPassword,
      onClickCancel: onClickCancel,
      errorMessage: errorMessage
    }, formData)), createElement(FooterComponent, {
      className: "Footer"
    })));
  };

  return CMSForgotPassword;
}(Component);

var HOME_PATH = '/';
var LOGIN_PATH = '/login/';
var SIGN_UP_PATH = '/sign-up/';
var SIGN_UP_COMPLETED_PATH = '/sign-up/completed/';
var FORGOT_PASSWORD_PATH = '/iforgot/';
var FORGOT_PASSWORD_COMPLETED_PATH = '/iforgot/sent';

var CMS =
/** @class */
function (_super) {
  __extends(CMS, _super);

  function CMS(props) {
    var _this = _super.call(this, props) || this;

    _this.unsubscribes = [];

    _this.onContextChanged = function () {
      _this.forceUpdate();
    };

    _this.onManagerReadyStateChanged = function () {
      _this.forceUpdate();
    };

    _this.onAuthenticationStateChanged = function (user) {
      _this.setState({
        user: user
      });
    };

    _this.onClickMenuIcon = function (event) {
      event.preventDefault();

      _this.setState({
        showMenuContainer: true
      }, function () {
        return setTimeout(function () {
          return _this.setState({
            showMenu: true
          });
        }, 10);
      });
    };

    _this.onClickMenuItem = function (itemProps) {
      var onClick = itemProps.onClick || function () {
        return null;
      };

      onClick(itemProps);

      _this.onDismissMenu();
    };

    _this.onDismissMenu = function () {
      _this.setState({
        showMenu: false
      }, function () {
        return setTimeout(function () {
          return _this.setState({
            showMenuContainer: false
          });
        }, 300);
      });
    };

    _this.onClickUserIcon = function (event) {
      event.preventDefault();

      _this.setState({
        showAccountMenuContainer: true
      }, function () {
        return setTimeout(function () {
          return _this.setState({
            showAccountMenu: true
          });
        }, 10);
      });
    };

    _this.onDismissAccountMenu = function () {
      _this.setState({
        showAccountMenu: false
      }, function () {
        return setTimeout(function () {
          return _this.setState({
            showAccountMenuContainer: false
          });
        }, 300);
      });
    };

    _this.onSignInCompleted = function () {
      _this.forceUpdate();
    };

    _this.onSignUpCompleted = function () {
      _this.forceUpdate(function () {
        _this._pushPath(SIGN_UP_COMPLETED_PATH)();
      });
    };

    _this.onForgotPasswordCompleted = function () {
      _this._pushPath(FORGOT_PASSWORD_COMPLETED_PATH)();
    };

    _this.attachToManager = function (manager) {
      if (!manager) {
        return;
      }

      _this.unsubscribes = [manager.onManagerReadyStateChanged(_this.onManagerReadyStateChanged), manager.onAuthenticationStateChanged(_this.onAuthenticationStateChanged)];
    };

    _this.onClickShowAccountSettings = function () {
      _this._pushPath('/account-settings/')();

      _this.onDismissAccountMenu();
    };

    _this.onClickSignOut = function () {
      var authenticationManager = _this.props.authenticationManager;

      if (authenticationManager) {
        authenticationManager.signOut();
      }

      _this.onDismissAccountMenu();
    };

    _this._pushPath = function (path) {
      return function () {
        var history = _this.state.cmsContext.history;

        if (history) {
          history.push(path);
        }
      };
    };

    _this.state = {
      showMenuContainer: false,
      showMenu: false,
      showAccountMenuContainer: false,
      showAccountMenu: false,
      cmsContext: new CMSContext(_this.props.history, _this.onContextChanged)
    };

    _this.attachToManager(_this.props.authenticationManager);

    return _this;
  }

  CMS.prototype.componentWillUnmount = function () {
    //detach from current manager
    this.unsubscribes.forEach(function (f) {
      return f();
    });
  };

  CMS.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        history = _a.history,
        authenticationManager = _a.authenticationManager;

    if (prevProps.history != history) {
      this.state.cmsContext.history = history;
    }

    if (prevProps.authenticationManager != authenticationManager) {
      this.unsubscribes.forEach(function (f) {
        return f();
      }); //detach from current manager

      this.attachToManager(authenticationManager);
    }
  };

  CMS.prototype.render = function () {
    var _this = this;

    var authenticationManager = this.props.authenticationManager;
    var _a = this.props,
        _b = _a.theme,
        theme = _b === void 0 ? CMSDefaultTheme : _b,
        _c = _a.headerTitle,
        headerTitle = _c === void 0 ? 'CR38TE CMS' : _c,
        _d = _a.headerSubtitle,
        headerSubtitle = _d === void 0 ? 'The CMS Framework' : _d,
        _e = _a.HeaderComponent,
        HeaderComponent = _e === void 0 ? CMSHeader : _e,
        _f = _a.MenuComponent,
        MenuComponent = _f === void 0 ? CMSMenu : _f,
        _g = _a.AccountMenuComponent,
        AccountMenuComponent = _g === void 0 ? CMSAccountMenu : _g,
        _h = _a.FooterComponent,
        FooterComponent = _h === void 0 ? React__default.Fragment : _h,
        _j = _a.showLogin,
        showLogin = _j === void 0 ? authenticationManager && !authenticationManager.isSignedIn() || false : _j,
        _k = _a.loading,
        loading = _k === void 0 ? authenticationManager && !authenticationManager.isReady() || false : _k,
        _l = _a.LoginComponent,
        LoginComponent = _l === void 0 ? CMSLogin : _l,
        _m = _a.SignUpComponent,
        SignUpComponent = _m === void 0 ? CMSSignUp : _m,
        _o = _a.SignUpCompletedComponent,
        SignUpCompletedComponent = _o === void 0 ? function () {
      return React__default.createElement(Redirect$1, {
        to: HOME_PATH
      });
    } : _o,
        _p = _a.ForgotPasswordComponent,
        ForgotPasswordComponent = _p === void 0 ? CMSForgotPassword : _p,
        _q = _a.ForgotPasswordCompletedComponent,
        ForgotPasswordCompletedComponent = _q === void 0 ? function () {
      return React__default.createElement(Redirect$1, {
        to: HOME_PATH
      });
    } : _q,
        children = _a.children,
        _r = _a.onSignUp,
        onSignUp = _r === void 0 ? authenticationManager && authenticationManager.signUp || null : _r,
        _s = _a.onSignIn,
        onSignIn = _s === void 0 ? authenticationManager && authenticationManager.signIn || null : _s,
        _t = _a.onForgotPassword,
        onForgotPassword = _t === void 0 ? authenticationManager && authenticationManager.forgotPassword || null : _t;
    var _u = this.state,
        showMenuContainer = _u.showMenuContainer,
        showMenu = _u.showMenu,
        showAccountMenuContainer = _u.showAccountMenuContainer,
        showAccountMenu = _u.showAccountMenu,
        cmsContext = _u.cmsContext,
        user = _u.user;
    return React__default.createElement(ThemeProvider, {
      theme: theme
    }, loading ? React__default.createElement(CMSLoader, {
      animating: true
    }) : React__default.createElement(Router$1, {
      history: cmsContext.history
    }, React__default.createElement(CMSGlobalStyle, null), showLogin ? React__default.createElement(Switch$1, null, React__default.createElement(Route, {
      path: LOGIN_PATH,
      exact: true,
      render: function render() {
        return React__default.createElement(LoginComponent, {
          onClickSignUp: _this._pushPath(SIGN_UP_PATH),
          onSignIn: onSignIn,
          onClickForgotPassword: _this._pushPath(FORGOT_PASSWORD_PATH),
          onSignInCompleted: _this.onSignInCompleted
        });
      }
    }), React__default.createElement(Route, {
      path: SIGN_UP_PATH,
      exact: true,
      render: function render() {
        return React__default.createElement(SignUpComponent, {
          onSignUp: onSignUp,
          onSignUpCompleted: _this.onSignUpCompleted,
          onClickCancel: _this._pushPath(LOGIN_PATH)
        });
      }
    }), React__default.createElement(Route, {
      path: FORGOT_PASSWORD_PATH,
      exact: true,
      render: function render() {
        return React__default.createElement(ForgotPasswordComponent, {
          onForgotPassword: onForgotPassword,
          onForgotPasswordCompleted: _this.onForgotPasswordCompleted,
          onClickCancel: _this._pushPath(LOGIN_PATH)
        });
      }
    }), React__default.createElement(Route, {
      path: FORGOT_PASSWORD_COMPLETED_PATH,
      exact: true,
      render: function render() {
        return React__default.createElement(ForgotPasswordCompletedComponent, null);
      }
    }), React__default.createElement(Redirect$1, {
      to: LOGIN_PATH
    })) : React__default.createElement(Switch$1, null, React__default.createElement(Route, {
      path: SIGN_UP_COMPLETED_PATH,
      exact: true,
      render: function render() {
        return React__default.createElement(SignUpCompletedComponent, null);
      }
    }), React__default.createElement(Route, {
      render: function render() {
        return React__default.createElement(CMSComponent, {
          headerTitle: headerTitle,
          headerSubtitle: headerSubtitle,
          HeaderComponent: HeaderComponent,
          MenuComponent: MenuComponent,
          FooterComponent: FooterComponent,
          showMenuContainer: showMenuContainer,
          showMenu: showMenu,
          AccountMenuComponent: AccountMenuComponent,
          showAccountMenuContainer: showAccountMenuContainer,
          showAccountMenu: showAccountMenu,
          cmsContext: cmsContext,
          onDismissMenu: _this.onDismissMenu,
          onDismissAccountMenu: _this.onDismissAccountMenu,
          onClickMenuItem: _this.onClickMenuItem,
          onClickMenuIcon: _this.onClickMenuIcon,
          onClickUserIcon: _this.onClickUserIcon,
          history: cmsContext.history,
          user: user,
          onClickShowAccountSettings: _this.onClickShowAccountSettings,
          onClickSignOut: _this.onClickSignOut
        }, children);
      }
    }))));
  };

  return CMS;
}(Component);

export { AuthenticationManagerImp as AuthenticationManager, CMS, CMSAvatar, CMSButton, CMSCheckbox, CMSDefaultTheme, CMSField, CMSFieldContainer, CMSFieldMessage, CMSFieldTitle, CMSForgotPassword, CMSHeader, CMSLoader, CMSLogin, CMSMenu, CMSScreen, CMSSignUp, CMSTextField, CMSTitle };